import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { executeOnSingleOrMultiple, isBoolean, safeMatchMedia } from "../../Utils/Utils";
import { mouseDownEvent, mouseLeaveEvent, mouseMoveEvent, mouseOutEvent, mouseUpEvent, resizeEvent, touchCancelEvent, touchEndEvent, touchMoveEvent, touchStartEvent, visibilityChangeEvent } from "./Constants";

function manageListener(element, event, handler, add, options) {
  if (add) {
    var addOptions = {
      passive: true
    };

    if (isBoolean(options)) {
      addOptions.capture = options;
    } else if (options !== undefined) {
      addOptions = options;
    }

    element.addEventListener(event, handler, addOptions);
  } else {
    var removeOptions = options;
    element.removeEventListener(event, handler, removeOptions);
  }
}

export var EventListeners = /*#__PURE__*/function () {
  function EventListeners(container) {
    var _this = this;

    _classCallCheck(this, EventListeners);

    this.container = container;

    this._doMouseTouchClick = function (e) {
      var container = _this.container,
          options = container.actualOptions;

      if (_this._canPush) {
        var mouseInteractivity = container.interactivity.mouse,
            mousePos = mouseInteractivity.position;

        if (!mousePos) {
          return;
        }

        mouseInteractivity.clickPosition = _objectSpread({}, mousePos);
        mouseInteractivity.clickTime = new Date().getTime();
        var onClick = options.interactivity.events.onClick;
        executeOnSingleOrMultiple(onClick.mode, function (mode) {
          return _this.container.handleClickMode(mode);
        });
      }

      if (e.type === "touchend") {
        setTimeout(function () {
          return _this._mouseTouchFinish();
        }, 500);
      }
    };

    this._handleThemeChange = function (e) {
      var mediaEvent = e,
          container = _this.container,
          options = container.options,
          defaultThemes = options.defaultThemes,
          themeName = mediaEvent.matches ? defaultThemes.dark : defaultThemes.light,
          theme = options.themes.find(function (theme) {
        return theme.name === themeName;
      });

      if (theme && theme.default.auto) {
        container.loadTheme(themeName);
      }
    };

    this._handleVisibilityChange = function () {
      var container = _this.container,
          options = container.actualOptions;

      _this._mouseTouchFinish();

      if (!options.pauseOnBlur) {
        return;
      }

      if (document && document.hidden) {
        container.pageHidden = true;
        container.pause();
      } else {
        container.pageHidden = false;

        if (container.getAnimationStatus()) {
          container.play(true);
        } else {
          container.draw(true);
        }
      }
    };

    this._handleWindowResize = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this._resizeTimeout) {
                clearTimeout(_this._resizeTimeout);
                delete _this._resizeTimeout;
              }

              _this._resizeTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var canvas;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        canvas = _this.container.canvas;
                        _context.t0 = canvas;

                        if (!_context.t0) {
                          _context.next = 5;
                          break;
                        }

                        _context.next = 5;
                        return canvas.windowResize();

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), _this.container.actualOptions.interactivity.events.resize.delay * 1000);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    this._manageInteractivityListeners = function (mouseLeaveTmpEvent, add) {
      var handlers = _this._handlers,
          container = _this.container,
          options = container.actualOptions;
      var interactivityEl = container.interactivity.element;

      if (!interactivityEl) {
        return;
      }

      var html = interactivityEl,
          canvasEl = container.canvas.element;

      if (canvasEl) {
        canvasEl.style.pointerEvents = html === canvasEl ? "initial" : "none";
      }

      if (!(options.interactivity.events.onHover.enable || options.interactivity.events.onClick.enable)) {
        return;
      }

      manageListener(interactivityEl, mouseMoveEvent, handlers.mouseMove, add);
      manageListener(interactivityEl, touchStartEvent, handlers.touchStart, add);
      manageListener(interactivityEl, touchMoveEvent, handlers.touchMove, add);

      if (!options.interactivity.events.onClick.enable) {
        manageListener(interactivityEl, touchEndEvent, handlers.touchEnd, add);
      } else {
        manageListener(interactivityEl, touchEndEvent, handlers.touchEndClick, add);
        manageListener(interactivityEl, mouseUpEvent, handlers.mouseUp, add);
        manageListener(interactivityEl, mouseDownEvent, handlers.mouseDown, add);
      }

      manageListener(interactivityEl, mouseLeaveTmpEvent, handlers.mouseLeave, add);
      manageListener(interactivityEl, touchCancelEvent, handlers.touchCancel, add);
    };

    this._manageListeners = function (add) {
      var handlers = _this._handlers,
          container = _this.container,
          options = container.actualOptions,
          detectType = options.interactivity.detectsOn,
          canvasEl = container.canvas.element;
      var mouseLeaveTmpEvent = mouseLeaveEvent;

      if (detectType === "window") {
        container.interactivity.element = window;
        mouseLeaveTmpEvent = mouseOutEvent;
      } else if (detectType === "parent" && canvasEl) {
        var _canvasEl$parentEleme;

        container.interactivity.element = (_canvasEl$parentEleme = canvasEl.parentElement) !== null && _canvasEl$parentEleme !== void 0 ? _canvasEl$parentEleme : canvasEl.parentNode;
      } else {
        container.interactivity.element = canvasEl;
      }

      _this._manageMediaMatch(add);

      _this._manageResize(add);

      _this._manageInteractivityListeners(mouseLeaveTmpEvent, add);

      if (document) {
        manageListener(document, visibilityChangeEvent, handlers.visibilityChange, add, false);
      }
    };

    this._manageMediaMatch = function (add) {
      var handlers = _this._handlers,
          mediaMatch = safeMatchMedia("(prefers-color-scheme: dark)");

      if (!mediaMatch) {
        return;
      }

      if (mediaMatch.addEventListener !== undefined) {
        manageListener(mediaMatch, "change", handlers.themeChange, add);
        return;
      }

      if (mediaMatch.addListener === undefined) {
        return;
      }

      if (add) {
        mediaMatch.addListener(handlers.oldThemeChange);
      } else {
        mediaMatch.removeListener(handlers.oldThemeChange);
      }
    };

    this._manageResize = function (add) {
      var handlers = _this._handlers,
          container = _this.container,
          options = container.actualOptions;

      if (!options.interactivity.events.resize) {
        return;
      }

      if (typeof ResizeObserver === "undefined") {
        manageListener(window, resizeEvent, handlers.resize, add);
        return;
      }

      var canvasEl = container.canvas.element;

      if (_this._resizeObserver && !add) {
        if (canvasEl) {
          _this._resizeObserver.unobserve(canvasEl);
        }

        _this._resizeObserver.disconnect();

        delete _this._resizeObserver;
      } else if (!_this._resizeObserver && add && canvasEl) {
        _this._resizeObserver = new ResizeObserver( /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(entries) {
            var entry;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    entry = entries.find(function (e) {
                      return e.target === canvasEl;
                    });

                    if (entry) {
                      _context3.next = 3;
                      break;
                    }

                    return _context3.abrupt("return");

                  case 3:
                    _context3.next = 5;
                    return _this._handleWindowResize();

                  case 5:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }());

        _this._resizeObserver.observe(canvasEl);
      }
    };

    this._mouseDown = function () {
      var interactivity = _this.container.interactivity;

      if (!interactivity) {
        return;
      }

      var mouse = interactivity.mouse;
      mouse.clicking = true;
      mouse.downPosition = mouse.position;
    };

    this._mouseTouchClick = function (e) {
      var container = _this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse;
      mouse.inside = true;
      var handled = false;
      var mousePosition = mouse.position;

      if (!mousePosition || !options.interactivity.events.onClick.enable) {
        return;
      }

      var _iterator = _createForOfIteratorHelper(container.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (!plugin.clickPositionValid) {
            continue;
          }

          handled = plugin.clickPositionValid(mousePosition);

          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!handled) {
        _this._doMouseTouchClick(e);
      }

      mouse.clicking = false;
    };

    this._mouseTouchFinish = function () {
      var interactivity = _this.container.interactivity;

      if (!interactivity) {
        return;
      }

      var mouse = interactivity.mouse;
      delete mouse.position;
      delete mouse.clickPosition;
      delete mouse.downPosition;
      interactivity.status = mouseLeaveEvent;
      mouse.inside = false;
      mouse.clicking = false;
    };

    this._mouseTouchMove = function (e) {
      var container = _this.container,
          options = container.actualOptions,
          interactivity = container.interactivity,
          canvasEl = container.canvas.element;

      if (!interactivity || !interactivity.element) {
        return;
      }

      interactivity.mouse.inside = true;
      var pos;

      if (e.type.startsWith("pointer")) {
        _this._canPush = true;
        var mouseEvent = e;

        if (interactivity.element === window) {
          if (canvasEl) {
            var clientRect = canvasEl.getBoundingClientRect();
            pos = {
              x: mouseEvent.clientX - clientRect.left,
              y: mouseEvent.clientY - clientRect.top
            };
          }
        } else if (options.interactivity.detectsOn === "parent") {
          var source = mouseEvent.target,
              target = mouseEvent.currentTarget;

          if (source && target && canvasEl) {
            var sourceRect = source.getBoundingClientRect(),
                targetRect = target.getBoundingClientRect(),
                canvasRect = canvasEl.getBoundingClientRect();
            pos = {
              x: mouseEvent.offsetX + 2 * sourceRect.left - (targetRect.left + canvasRect.left),
              y: mouseEvent.offsetY + 2 * sourceRect.top - (targetRect.top + canvasRect.top)
            };
          } else {
            var _mouseEvent$offsetX, _mouseEvent$offsetY;

            pos = {
              x: (_mouseEvent$offsetX = mouseEvent.offsetX) !== null && _mouseEvent$offsetX !== void 0 ? _mouseEvent$offsetX : mouseEvent.clientX,
              y: (_mouseEvent$offsetY = mouseEvent.offsetY) !== null && _mouseEvent$offsetY !== void 0 ? _mouseEvent$offsetY : mouseEvent.clientY
            };
          }
        } else if (mouseEvent.target === canvasEl) {
          var _mouseEvent$offsetX2, _mouseEvent$offsetY2;

          pos = {
            x: (_mouseEvent$offsetX2 = mouseEvent.offsetX) !== null && _mouseEvent$offsetX2 !== void 0 ? _mouseEvent$offsetX2 : mouseEvent.clientX,
            y: (_mouseEvent$offsetY2 = mouseEvent.offsetY) !== null && _mouseEvent$offsetY2 !== void 0 ? _mouseEvent$offsetY2 : mouseEvent.clientY
          };
        }
      } else {
        _this._canPush = e.type !== "touchmove";

        if (canvasEl) {
          var _canvasRect$left, _canvasRect$top;

          var touchEvent = e,
              lastTouch = touchEvent.touches[touchEvent.touches.length - 1],
              _canvasRect = canvasEl.getBoundingClientRect();

          pos = {
            x: lastTouch.clientX - ((_canvasRect$left = _canvasRect.left) !== null && _canvasRect$left !== void 0 ? _canvasRect$left : 0),
            y: lastTouch.clientY - ((_canvasRect$top = _canvasRect.top) !== null && _canvasRect$top !== void 0 ? _canvasRect$top : 0)
          };
        }
      }

      var pxRatio = container.retina.pixelRatio;

      if (pos) {
        pos.x *= pxRatio;
        pos.y *= pxRatio;
      }

      interactivity.mouse.position = pos;
      interactivity.status = mouseMoveEvent;
    };

    this._touchEnd = function (e) {
      var evt = e,
          touches = Array.from(evt.changedTouches);

      for (var _i = 0, _touches = touches; _i < _touches.length; _i++) {
        var touch = _touches[_i];

        _this._touches.delete(touch.identifier);
      }

      _this._mouseTouchFinish();
    };

    this._touchEndClick = function (e) {
      var evt = e,
          touches = Array.from(evt.changedTouches);

      for (var _i2 = 0, _touches2 = touches; _i2 < _touches2.length; _i2++) {
        var touch = _touches2[_i2];

        _this._touches.delete(touch.identifier);
      }

      _this._mouseTouchClick(e);
    };

    this._touchStart = function (e) {
      var evt = e,
          touches = Array.from(evt.changedTouches);

      for (var _i3 = 0, _touches3 = touches; _i3 < _touches3.length; _i3++) {
        var touch = _touches3[_i3];

        _this._touches.set(touch.identifier, performance.now());
      }

      _this._mouseTouchMove(e);
    };

    this._canPush = true;
    this._touches = new Map();
    this._handlers = {
      mouseDown: function mouseDown() {
        return _this._mouseDown();
      },
      mouseLeave: function mouseLeave() {
        return _this._mouseTouchFinish();
      },
      mouseMove: function mouseMove(e) {
        return _this._mouseTouchMove(e);
      },
      mouseUp: function mouseUp(e) {
        return _this._mouseTouchClick(e);
      },
      touchStart: function touchStart(e) {
        return _this._touchStart(e);
      },
      touchMove: function touchMove(e) {
        return _this._mouseTouchMove(e);
      },
      touchEnd: function touchEnd(e) {
        return _this._touchEnd(e);
      },
      touchCancel: function touchCancel(e) {
        return _this._touchEnd(e);
      },
      touchEndClick: function touchEndClick(e) {
        return _this._touchEndClick(e);
      },
      visibilityChange: function visibilityChange() {
        return _this._handleVisibilityChange();
      },
      themeChange: function themeChange(e) {
        return _this._handleThemeChange(e);
      },
      oldThemeChange: function oldThemeChange(e) {
        return _this._handleThemeChange(e);
      },
      resize: function resize() {
        _this._handleWindowResize();
      }
    };
  }

  _createClass(EventListeners, [{
    key: "addListeners",
    value: function addListeners() {
      this._manageListeners(true);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      this._manageListeners(false);
    }
  }]);

  return EventListeners;
}();